var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4C23.1046 4 24 4.89543 24 6V18C24 19.1046 23.1046 20 22 20H2C0.895431 20 0 19.1046 0 18V6C0 4.89543 0.895431 4 2 4H22ZM9 16L16 12L9 8V16Z",
    fill: "#2371C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGuide);
export default __webpack_public_path__ + "static/media/videoGuide.cbf592b5171198068a45588aba658caf.svg";
export { ForwardRef as ReactComponent };